/**
 * Generated by orval 🍺
 * Do not edit manually.
 * QPM API
 * OpenAPI spec version: 0.1.0
 */
import {
  useQuery
} from '@tanstack/react-query';
import type {
  QueryFunction,
  QueryKey,
  UseQueryOptions,
  UseQueryResult
} from '@tanstack/react-query';

import type {
  BacktestResponse,
  HTTPValidationError
} from '../../models';

import { customMutator } from '../../api.ts';

type AwaitedInput<T> = PromiseLike<T> | T;

      type Awaited<O> = O extends AwaitedInput<infer T> ? T : never;


type SecondParameter<T extends (...args: never) => unknown> = Parameters<T>[1];



const withQueryKey = <T extends object, K>(query: T, queryKey: K): T & { queryKey: K } => {
  const result = { queryKey } as T & { queryKey: K };
  for (const key of Object.keys(query)) {
    // The explicit queryKey always wins, matching the previous
    // `{ ...query, queryKey }` spread where it was set last.
    if (key === 'queryKey') continue;
    Object.defineProperty(result, key, {
      enumerable: true,
      configurable: true,
      get: () => (query as Record<string, unknown>)[key],
    });
  }
  return result;
};

/**
 * Get a single backtest with its current status.
 * @summary Get Backtest
 */
export const getBacktest = (
    backtestId: string,
 options?: SecondParameter<typeof customMutator>,signal?: AbortSignal
) => {


      return customMutator<BacktestResponse>(
      {url: `/backtests/${backtestId}`, method: 'GET', signal
    },
      options);
    }




export const getGetBacktestQueryKey = (backtestId: string,) => {
    return [
    `/backtests/${backtestId}`
    ] as const;
    }


export const getGetBacktestQueryOptions = <TData = Awaited<ReturnType<typeof getBacktest>>, TError = HTTPValidationError>(backtestId: string, options?: { query?:UseQueryOptions<Awaited<ReturnType<typeof getBacktest>>, TError, TData>, request?: SecondParameter<typeof customMutator>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getGetBacktestQueryKey(backtestId);



    const queryFn: QueryFunction<Awaited<ReturnType<typeof getBacktest>>> = ({ signal }) => getBacktest(backtestId, requestOptions, signal);





   return  { queryKey, queryFn, enabled: backtestId !== null && backtestId !== undefined, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof getBacktest>>, TError, TData> & { queryKey: QueryKey }
}

export type GetBacktestQueryResult = NonNullable<Awaited<ReturnType<typeof getBacktest>>>
export type GetBacktestQueryError = HTTPValidationError


/**
 * @summary Get Backtest
 */

export function useGetBacktest<TData = Awaited<ReturnType<typeof getBacktest>>, TError = HTTPValidationError>(
 backtestId: string, options?: { query?:UseQueryOptions<Awaited<ReturnType<typeof getBacktest>>, TError, TData>, request?: SecondParameter<typeof customMutator>}

 ):  UseQueryResult<TData, TError> & { queryKey: QueryKey } {

  const queryOptions = getGetBacktestQueryOptions(backtestId,options)

  const query = useQuery(queryOptions) as  UseQueryResult<TData, TError> & { queryKey: QueryKey };

  return withQueryKey(query, queryOptions.queryKey);
}






